import ITodo from "../interfaces/ITodo"
import Todo from "./Todo";

const TodoContainer = ({todos}:{todos:Array<ITodo>}) => {
    
    return (
        <>
            {
                todos.map(({id,completed,content}) => <Todo key={id} id={id} completed={completed} content={content}></Todo>)
            }
        </>
    )
}

export default TodoContainer